import CloseIcon from "assets/svg/CloseIcon";

const PollInformationBanner = ({
  onTryNow,
  showPollInfoBanner,
  setShowPollInfoBanner,
}) => {
  if (!showPollInfoBanner) return;
  return (
    <div className="flex flex-col rounded-md border p-5 items-center gap-3 relative">
      <button
        onClick={() => setShowPollInfoBanner(false)}
        className="flex items-center justify-center ml-auto absolute top-2 right-2"
      >
        <CloseIcon className={"w-6 h-6"} fill="#2e2e2e" />
      </button>
      <div className="flex flex-col items-center gap-1">
        <span className="font-bold text-charcoal">
          Let’s Make Scheduling Easy!
        </span>
        <span className="font-semibold text-xs text-light-black">
          Your choices shape the meeting
        </span>
      </div>
      <span className="font-medium text-xs text-light-black text-center my-3">
        Select all the slots you’re available for. The candidate will pick a
        time that fits most people—your input counts!
      </span>
      <div className="flex items-center gap-4">
        <button
          onClick={onTryNow}
          className="text-white font-semibold text-sm py-1.5 border px-3 rounded-md bg-primary hover:bg-black"
        >
          Try it now !
        </button>
        <button
          onClick={() => setShowPollInfoBanner(false)}
          className="bg-white font-semibold py-1 px-3 rounded-md text-charcoal border-primary border hover:bg-gray-100"
        >
          Later
        </button>
      </div>
    </div>
  );
};

export default PollInformationBanner;
